@if (!opened()) {
  <div class="fixed right-0 top-1/2 z-9999 -translate-y-1/2">
    <bevvi-widget (buttonClick)="toggleChat()" />
  </div>
}

@if (opened()) {
  <div
    class="fixed inset-0 z-9999 sm:inset-auto sm:right-0 sm:top-0 sm:h-screen sm:flex sm:flex-row sm:items-stretch"
    [class]="closing() ? 'sm:chat-slide-out' : 'sm:chat-slide-in'"
  >
    <div class="hidden sm:flex sm:items-center">
      <bevvi-widget [expanded]="true" (buttonClick)="toggleChat()" />
    </div>
    <div class="h-full sm:w-100">
      <bevvi-chat-panel [closing]="closing()" (close)="toggleChat()" />
    </div>
  </div>

  <!-- Mobile backdrop -->
  <button
    type="button"
    class="fixed inset-0 z-9998 cursor-default bg-black/40 transition-opacity duration-300 sm:hidden"
    [class.opacity-0]="closing()"
    aria-label="Close chat"
    (click)="toggleChat()"
  ></button>
}
